/* PURE LAB — behaviour written for this store. Loaded as a classic script, deferred. */

/* ============================================================
   Locale link guard - a patch over a Shopify quirk, not a feature.

   Shopify builds internal links from the PRIMARY language's root. Here the primary
   language is English, which lives at /en, while the shop itself opens in Estonian at
   the root. On a first visit - before the session cookie exists, which is also how
   Googlebot sees the site - every link on the Estonian and Russian pages therefore came
   out as /en/..., and the first click dropped the visitor into English.

   In Liquid there is nothing to fix it with: request.locale.root_url is correct, but
   link.url, product.url and routes.* all carry the wrong prefix already, at a hundred
   places. So the links are repaired in the page instead: on an Estonian page /en/... loses
   the prefix, on a Russian one it becomes /ru/..., and on the English pages nothing is
   touched. When the language links are already right - a returning visitor - this does
   nothing at all.

   The real fix is in the admin: the primary language has to be the one served at the
   root. Until that happens, this stays.
   ============================================================ */
(function(){
  var PRIMARY = '/en';
  var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
  if (!lang || lang.indexOf('en') === 0) return;

  var want = lang.indexOf('ru') === 0 ? '/ru' : '';

  function repaired(value){
    if (!value) return null;

    var origin = '';
    var path = value;
    var scheme = value.indexOf('//');
    if (scheme === 0 || scheme === 5 || scheme === 6) {
      var slash = value.indexOf('/', scheme + 2);
      if (slash === -1) return null;
      origin = value.slice(0, slash);
      if (origin.indexOf(location.host) === -1) return null;   // чужой домен не трогаем
      path = value.slice(slash);
    } else if (value.charAt(0) !== '/') {
      return null;                                             // #, mailto:, tel:, относительные
    }

    if (path.slice(0, PRIMARY.length) !== PRIMARY) return null;

    // /en, /en/... и /en?... - да; /entrance - нет.
    var tail = path.slice(PRIMARY.length);
    if (tail !== '' && tail.charAt(0) !== '/' && tail.charAt(0) !== '?') return null;

    // На эстонском префикса нет совсем, поэтому корень остаётся корнем: /en -> /,
    // /en?x=1 -> /?x=1.
    if (want === '' && (tail === '' || tail.charAt(0) === '?')) tail = '/' + tail;

    return origin + want + tail;
  }

  function sweep(root){
    if (!root || !root.querySelectorAll) return;
    var nodes = root.querySelectorAll('a[href], form[action]');
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      var attr = node.tagName === 'FORM' ? 'action' : 'href';
      var next = repaired(node.getAttribute(attr));
      if (next) node.setAttribute(attr, next);
    }
  }

  sweep(document);
  document.addEventListener('DOMContentLoaded', function(){ sweep(document); });

  // Ящики, поиск и блок рекомендаций подставляют разметку позже - её тоже чиним.
  if (window.MutationObserver) {
    new MutationObserver(function(records){
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) sweep(added[j]);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();

/* ============================================================
   Mega menu: nested submenu toggles
   ============================================================ */
(function(){
  document.addEventListener('click', function(e){
    var btn = e.target.closest('.mega-submenu-toggle');
    if(!btn) return;
    e.preventDefault();
    var wrap = btn.nextElementSibling;
    if(!wrap || !wrap.classList.contains('mega-submenu-wrap')) return;
    var open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!open));
    wrap.classList.toggle('is-open', !open);
  });
})();

/* ============================================================
   Account dialog
   ============================================================ */
  (function () {
    var dialog = document.getElementById('account-dialog');
    if (!dialog) return;

    var triggers = document.querySelectorAll('[data-account-open]');
    var panel = dialog.querySelector('.account-dialog__panel');
    var form = dialog.querySelector('[data-account-form]');
    var input = dialog.querySelector('#account-dialog-email');
    var submit = dialog.querySelector('.account-dialog__submit');
    var lastTrigger = null;
    var closeTimer = null;

    function openDialog(trigger) {
      lastTrigger = trigger || null;
      clearTimeout(closeTimer);
      dialog.hidden = false;
      triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
      requestAnimationFrame(function () { dialog.classList.add('is-open'); });
      setTimeout(function () { input && input.focus(); }, 120);
    }

    function closeDialog() {
      dialog.classList.remove('is-open');
      triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      closeTimer = setTimeout(function () { dialog.hidden = true; }, 220);
      if (lastTrigger) lastTrigger.focus();
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        if (dialog.hidden) openDialog(trigger); else closeDialog();
      });
    });

    dialog.querySelectorAll('[data-account-close]').forEach(function (el) {
      el.addEventListener('click', closeDialog);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !dialog.hidden) closeDialog();
    });

    if (input && submit) {
      input.addEventListener('input', function () {
        submit.disabled = input.value.trim().length === 0;
      });
    }

    /* The form used to swallow its own submit, so the arrow did nothing at all. It now
       carries the address typed here over to Shopify's login page. */
    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();

        var email = input ? input.value.trim() : '';
        var target = form.getAttribute('action') || '/account/login';
        if (email) {
          target += (target.indexOf('?') === -1 ? '?' : '&') + 'email=' + encodeURIComponent(email);
        }

        if (submit) submit.disabled = true;
        window.location.href = target;
      });
    }

    if (panel) {
      panel.addEventListener('keydown', function (event) {
        if (event.key !== 'Tab') return;
        var focusable = panel.querySelectorAll('button, input, a[href]');
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    }
  })();

/* ============================================================
   Shop notice: shown once on entry, and after that it lives behind the bell.

   The key carries the text of the notices, so a rewritten notice is a new notice and
   comes up again; the same one never does. Nothing here decides when the notice stops -
   that is the date in the section settings, and by then this markup is simply absent.
   ============================================================ */
(function(){
  var overlay = document.getElementById('notice-overlay');
  if (!overlay) return;

  var ok = document.getElementById('notice-ok');
  var closeBtn = document.getElementById('notice-close');
  var KEY = 'purelab:notice:' + (overlay.getAttribute('data-notice-key') || '');

  function open(){
    overlay.classList.add('open');
    overlay.setAttribute('aria-hidden', 'false');
    if (ok) ok.focus();
  }

  function close(){
    overlay.classList.remove('open');
    overlay.setAttribute('aria-hidden', 'true');
    // Private mode simply means the notice greets them again next time - which is the
    // safer failure for something that has to be read.
    try { window.localStorage.setItem(KEY, '1'); } catch(e){}
  }

  if (ok) ok.addEventListener('click', close);
  if (closeBtn) closeBtn.addEventListener('click', close);
  overlay.addEventListener('click', function(e){ if (e.target === overlay) close(); });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && overlay.classList.contains('open')) close();
  });

  // The customizer always shows it, otherwise the merchant could not edit it.
  if (window.Shopify && window.Shopify.designMode) { open(); return; }

  var seen = false;
  try { seen = window.localStorage.getItem(KEY) === '1'; } catch(e){}
  if (seen) return;

  setTimeout(open, 350);
})();

/* ============================================================
   Newsletter popup
   ============================================================ */
(function(){
  var overlay = document.getElementById('nlp-overlay');
  var closeBtn = document.getElementById('nlp-close');
  var skip = document.getElementById('nlp-skip');
  var form = document.getElementById('nlp-form');
  if (!overlay || !closeBtn) return;

  var KEY = 'purelab:newsletter';
  var SEEN = 'purelab:newsletter-reminded';
  var DAY = 86400000;
  var SUBSCRIBED_DAYS = 365;

  // An answer is kept with its own expiry, so the popup can come back eventually
  // without ever nagging someone who has just closed it - or signed up.
  function remember(key, days){
    try {
      window.localStorage.setItem(key, JSON.stringify({ until: Date.now() + days * DAY }));
    } catch(e){ /* private mode: the popup behaves as it always did */ }
  }

  function answered(key){
    try {
      var stored = JSON.parse(window.localStorage.getItem(key));
      return !!stored && stored.until > Date.now();
    } catch(e){ return false; }
  }

  function open(){ overlay.classList.add('open'); overlay.setAttribute('aria-hidden','false'); }
  function close(){ overlay.classList.remove('open'); overlay.setAttribute('aria-hidden','true'); }

  var dismissDays = parseFloat(overlay.getAttribute('data-remember-days')) || 14;

  // Liquid places a signed-in visitor. For everybody else all we have is the mark left in
  // this browser when they signed up here, which knows they subscribed but not whether they
  // ever ordered - so the most it can do is turn the offer into a reminder.
  var state = overlay.getAttribute('data-state') || 'offer';
  if (state === 'offer' && answered(KEY) && subscribedHere()) state = 'remind';

  function subscribedHere(){
    try {
      var stored = JSON.parse(window.localStorage.getItem(KEY));
      return !!stored && stored.subscribed === true;
    } catch(e){ return false; }
  }

  function show(which){
    var panels = overlay.querySelectorAll('[data-nlp-panel]');
    for (var i = 0; i < panels.length; i++) {
      panels[i].hidden = panels[i].getAttribute('data-nlp-panel') !== which;
    }
  }
  show(state);

  function dismiss(){
    close();
    // A reminder that was waved away comes back on the ordinary schedule; the offer keeps
    // its own longer silence.
    remember(state === 'offer' ? KEY : SEEN, dismissDays);
  }

  closeBtn.addEventListener('click', dismiss);
  if (skip) skip.addEventListener('click', dismiss);
  var dismissers = overlay.querySelectorAll('[data-nlp-dismiss]');
  for (var d = 0; d < dismissers.length; d++) dismissers[d].addEventListener('click', dismiss);
  overlay.addEventListener('click', function(e){ if(e.target === overlay) dismiss(); });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && overlay.classList.contains('open')) dismiss(); });
  if (form) form.addEventListener('submit', function(){
    try {
      window.localStorage.setItem(KEY, JSON.stringify({
        until: Date.now() + SUBSCRIBED_DAYS * DAY, subscribed: true
      }));
    } catch(e){}
  });

  // The form reloads the page, so the confirmation arrives as a fresh render: show it
  // once, whatever the delay, and do not ask this visitor again for a year.
  if (overlay.querySelector('[data-nlp-subscribed]')) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify({
        until: Date.now() + SUBSCRIBED_DAYS * DAY, subscribed: true
      }));
    } catch(e){}
    show('offer');
    open();
    return;
  }

  // The customizer always shows it, otherwise the merchant could not edit it.
  var designMode = window.Shopify && window.Shopify.designMode;
  if (designMode) { open(); return; }

  // Nobody is told their discount is spent unless they go looking for it: popping that up
  // at a paying customer is a worse greeting than saying nothing at all.
  if (state === 'spent') return;
  if (state === 'remind' && answered(SEEN)) return;
  if (state === 'offer' && answered(KEY)) return;

  // A shop notice outranks an offer: while it is on screen the popup waits its turn, and
  // comes up only once the visitor has answered the thing they had to read.
  function openWhenFree(){
    var notice = document.querySelector('#notice-overlay.open');
    if (notice) { setTimeout(openWhenFree, 1000); return; }
    open();
  }

  var delay = (parseFloat(overlay.getAttribute('data-delay')) || 2) * 1000;
  setTimeout(openWhenFree, delay);
})();

/* ============================================================
   Treatments page: the booking button follows you down
   ============================================================ */
(function(){
  var bar = document.getElementById('treatments-sticky');
  var body = document.querySelector('.treatments__body');
  if (!bar || !body) return;

  var links = body.querySelectorAll('a[href*="anolla.com/book"]');
  if (!links.length) return;

  // The bar says whatever the page says. That is the whole point: the page is translated,
  // so the bar is translated, and there is no second string to keep in step.
  var first = links[0];
  var target = bar.querySelector('a');
  target.href = first.href;
  target.textContent = first.textContent.trim();
  bar.hidden = false;

  function show(on){
    bar.classList.toggle('is-visible', on);
    bar.setAttribute('aria-hidden', on ? 'false' : 'true');
  }

  // The same mechanism the product page's buy bar uses, and for the same reason: once the
  // button has scrolled past the top, the reader has none in view.
  if (!('IntersectionObserver' in window)) { show(false); return; }

  new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      show(!entry.isIntersecting && entry.boundingClientRect.top < 0);
    });
  }, { threshold: 0 }).observe(first);
})();

/* ============================================================
   Sticky bars step aside for the footer
   ============================================================ */
(function(){
  var bars = document.querySelectorAll('.pdp-sticky, .treatments-sticky');
  var footer = document.querySelector('.footer');
  if (!bars.length || !footer || !('IntersectionObserver' in window)) return;

  /* The footer holds the language switcher, among other things people actually press.
     A bar covering it is worse than a bar that disappears a screen early. */
  new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      for (var i = 0; i < bars.length; i++) {
        bars[i].classList.toggle('is-blocked', entry.isIntersecting);
      }
    });
  }, { threshold: 0 }).observe(footer);
})();

/* ============================================================
   Membership popup
   ============================================================ */
(function(){
  var launcher = document.getElementById('mbr-launcher');
  var pop      = document.getElementById('mbr-pop');
  var closeBtn = document.getElementById('mbr-close');
  if (!launcher || !pop || !closeBtn) return;
  function open(){ pop.classList.add('open'); launcher.classList.add('is-open'); document.documentElement.classList.add('mbr-open'); pop.setAttribute('aria-hidden','false'); }
  function close(){ pop.classList.remove('open'); launcher.classList.remove('is-open'); document.documentElement.classList.remove('mbr-open'); pop.setAttribute('aria-hidden','true'); }
  launcher.addEventListener('click', function(e){ e.stopPropagation(); pop.classList.contains('open') ? close() : open(); });
  closeBtn.addEventListener('click', close);
  pop.addEventListener('click', function(e){ e.stopPropagation(); });
  document.addEventListener('click', function(){ if(pop.classList.contains('open')) close(); });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') close(); });
})();

/* ============================================================
   Brush headline reveal
   ============================================================ */
(function(){
  var els = document.querySelectorAll('.brush-anim');
  if(!els.length) return;
  if(!('IntersectionObserver' in window)){ els.forEach(function(e){ e.classList.add('brush-in'); }); return; }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      if(en.isIntersecting){ en.target.classList.add('brush-in'); io.unobserve(en.target); }
    });
  }, { threshold: 0.45 });
  els.forEach(function(e){ io.observe(e); });
})();

/* The prototype rebuilt the description into accordions of its own, splitting it on
   its headings and emptying the container first. The description is one plain block
   now, with nothing to split on, so that script only ever wiped it. */

/* ============================================================
   Product page: accordions + sticky buy bar
   ============================================================ */
(function(){
  document.addEventListener('click', function(e){
    var btn = e.target.closest('.pdp-accordion__header');
    if(!btn) return;
    var wrap = btn.nextElementSibling;
    if(!wrap || !wrap.classList.contains('pdp-accordion__wrap')) return;
    var open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!open));
    wrap.classList.toggle('is-open', !open);
  });

  var bar = document.getElementById('pdp-sticky');
  var anchor = document.querySelector('.buy-buttons');
  if(!bar || !anchor || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){ bar.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0); });
  }, { threshold: 0 });
  io.observe(anchor);
})();

/* ============================================================
   Collection: infinite scroll
   ============================================================ */
(function(){
  var sentinel = document.getElementById('infinite-scroll-sentinel');
  var grid = document.getElementById('product-grid');

  /* The toolbar reports how many products are on screen, not how many the first
     page held, so it has to be recounted after every batch. */
  function updateProductCount(){
    var label = document.querySelector('[data-product-count]');
    if(!label || !grid) return;

    var template = label.getAttribute('data-template');
    if(!template) return;

    label.textContent = template
      .replace('__COUNT__', grid.children.length)
      .replace('__TOTAL__', label.getAttribute('data-total'));
  }
  var loading = document.getElementById('infinite-scroll-loading');
  var paginationNav = document.getElementById('pagination-nav');
  if(!sentinel || !grid) return;

  var isLoading = false;

  function loadNext(){
    var nextUrl = sentinel.getAttribute('data-next');
    if(!nextUrl || isLoading) return;
    isLoading = true;
    if(loading) loading.hidden = false;

    fetch(nextUrl)
      .then(function(res){ return res.text(); })
      .then(function(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextGrid = doc.getElementById('product-grid');
        var nextSentinel = doc.getElementById('infinite-scroll-sentinel');

        if(nextGrid){
          [].slice.call(nextGrid.children).forEach(function(card, i){
            card.classList.add('product-card--infinite-in');
            card.style.animationDelay = (i * 40) + 'ms';
            grid.appendChild(card);
          });

          updateProductCount();
        }

        // chain to whatever page comes after the one we just merged in, so page 3, 4... would keep working too
        var followingUrl = nextSentinel ? nextSentinel.getAttribute('data-next') : '';
        sentinel.setAttribute('data-next', followingUrl || '');
        if(!followingUrl){
          io.disconnect();
          sentinel.remove();
        }
      })
      .catch(function(){
        // fail quietly; the (hidden) pagination links still work as a manual fallback
      })
      .finally(function(){
        isLoading = false;
        if(loading) loading.hidden = true;
      });
  }

  // hide pagination only when there's actually a next page for infinite scroll to chain into;
  // on the last page, leave it visible so it still works as a way back
  if(paginationNav && sentinel.getAttribute('data-next')) paginationNav.style.display = 'none';

  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){ if(entry.isIntersecting) loadNext(); });
  }, { rootMargin: '150px 0px 0px 0px' });

  io.observe(sentinel);
})();

/* ============================================================
   Featured collections: tab switching
   ============================================================ */
(function () {
  document.addEventListener('click', function (event) {
    var tab = event.target.closest('[data-collection-tabs] [role="tab"]');
    if (!tab) return;

    var list = tab.closest('[data-collection-tabs]');
    var section = list.closest('.shopify-section') || document;

    list.querySelectorAll('[role="tab"]').forEach(function (node) {
      node.setAttribute('aria-selected', String(node === tab));
    });

    var target = tab.getAttribute('aria-controls');
    section.querySelectorAll('[role="tabpanel"]').forEach(function (panel) {
      panel.hidden = panel.id !== target;
    });
  });
})();

/* ============================================================
   Product page: keep the submitted variant id in sync
   The theme's <variant-picker> re-renders the section; this only guarantees the
   hidden id field matches the checked options, so add to cart is never wrong.
   ============================================================ */
(function () {
  var picker = document.querySelector('[data-variant-picker]');
  if (!picker) return;

  var formId = picker.getAttribute('form-id');
  var form = document.getElementById(formId);
  var idField = form && form.querySelector('[data-variant-id]');
  var source = picker.querySelector('script[data-variants]');
  if (!form || !idField || !source) return;

  var prices = null;
  var priceSource = picker.querySelector('script[data-variant-prices]');
  if (priceSource) {
    try {
      prices = JSON.parse(priceSource.textContent);
    } catch (error) {
      prices = null;
    }
  }

  var variants;
  try {
    variants = JSON.parse(source.textContent);
  } catch (error) {
    return;
  }

  function selectedOptions() {
    return Array.prototype.map.call(
      picker.querySelectorAll('input[data-option-position]:checked'),
      function (input) {
        return input.value;
      }
    );
  }

  function sync() {
    var chosen = selectedOptions();

    var match = variants.filter(function (candidate) {
      return chosen.every(function (value, index) {
        return candidate.options[index] === value;
      });
    })[0];

    if (!match) return;

    idField.value = match.id;

    var submit = form.querySelector('button[type="submit"]');
    if (submit) submit.disabled = match.available === false;

    /* Цена: берём готовую разметку, собранную темой для этого варианта.
       Считать её здесь нельзя - пришлось бы повторить логику скидок и
       закрытых цен из snippets/price-list.liquid. */
    if (prices) {
      var markup = prices[String(match.id)];
      var holder = document.querySelector('[data-block-type="price"]');
      var current = holder && holder.querySelector('price-list');
      if (markup && current) {
        var box = document.createElement('div');
        box.innerHTML = markup;
        var fresh = box.querySelector('price-list');
        if (fresh) current.replaceWith(fresh);
      }
    }

    /* Фотография варианта, если она к нему привязана */
    if (match.featured_media && match.featured_media.id) {
      var slide = document.querySelector(
        '[data-media-id="' + match.featured_media.id + '"], ' +
        '[data-media-id$="' + match.featured_media.id + '"]');
      if (slide && typeof slide.scrollIntoView === 'function') {
        slide.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    }
  }

  picker.addEventListener('change', function (event) {
    if (event.target.matches('input[data-option-position]')) sync();
  });

  sync();
})();


/* ============================================================
   Notice bell: hide it when there are no notices at all
   The panel renders only when the section has blocks, but the bell in the header
   is always printed - without this it would open nothing.
   ============================================================ */
(function () {
  if (document.getElementById('news-modal')) return;
  var bell = document.querySelector('.header__news-link');
  if (bell) bell.hidden = true;
})();


/* ============================================================
   Notice panel: the bell keeps a dot until this set of notices has been opened
   ============================================================ */
(function () {
  var panel = document.getElementById('news-modal');
  var dot = document.querySelector('[data-news-dot]');
  var signatureNode = document.querySelector('[data-news-signature]');
  if (!panel || !dot || !signatureNode) return;

  var signature;
  try {
    signature = JSON.parse(signatureNode.textContent);
  } catch (error) {
    return;
  }

  var KEY = 'purelab:news-seen';
  var seen = null;
  try {
    seen = window.localStorage.getItem(KEY);
  } catch (error) {
    /* private mode: the dot simply shows every visit */
  }

  dot.hidden = seen === signature;

  panel.addEventListener('dialog:after-show', function () {
    dot.hidden = true;
    try {
      window.localStorage.setItem(KEY, signature);
    } catch (error) {}
  });
})();

/* Язык, выбранный покупателем, живёт только в адресе: ru и en идут с префиксом,
   эстонский - без него. Чекаут языка в ссылке не передаёт: кнопка-логотип ведёт
   на корень магазина, и человек, читавший сайт по-русски, попадал на эстонскую
   версию. На тарифе Basic чекаут не правится, поэтому запоминаем выбор здесь.

   Кука ставится только по нажатию в переключателе языков, то есть по осознанному
   выбору. Это важно: у поисковых роботов куки нет, корень они по-прежнему видят
   эстонским, и выдача не меняется. Тот, кто язык не выбирал, тоже ничего не
   заметит. */
(function () {
  var KEY = 'purelab_lang';
  var PREFIXED = ['ru', 'en'];          /* эстонский - язык корня, без префикса */
  var YEAR = 60 * 60 * 24 * 365;

  function remember(code) {
    try {
      document.cookie = KEY + '=' + encodeURIComponent(code) +
        ';path=/;max-age=' + YEAR + ';SameSite=Lax';
    } catch (error) {
      /* куки запрещены - значит и перенаправлять будет нечему */
    }
  }

  function chosen() {
    var found = document.cookie.match(/(?:^|;\s*)purelab_lang=([^;]*)/);
    return found ? decodeURIComponent(found[1]) : '';
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[name="locale_code"]');
    if (button && button.value) {
      remember(button.value);
    }
  });

  var path = window.location.pathname;
  var first = path.split('/')[1];

  /* уже на языковой версии - запоминать и перенаправлять нечего */
  if (PREFIXED.indexOf(first) !== -1) {
    return;
  }

  /* служебные адреса Shopify не трогаем */
  if (/^\/(cdn|cart|checkouts?|apps|tools|services|wpm|\.well-known)(\/|$)/.test(path)) {
    return;
  }

  var want = chosen();
  if (PREFIXED.indexOf(want) === -1) {
    return;
  }

  window.location.replace('/' + want + path + window.location.search + window.location.hash);
})();
